import { useEffect, useState } from "react";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { api } from "@/lib/api";

export default function DrawdownChart({ code }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/funds/${code}/drawdown`).then((r) => setData(r.data));
  }, [code]);

  return (
    <section
      data-testid="drawdown-section"
      className="bg-white border border-sif rounded-xl p-4 sm:p-6 card-shadow mb-6"
    >
      <div className="flex items-start justify-between flex-wrap mb-4 gap-2">
        <div>
          <div className="text-xs text-sif-muted uppercase tracking-wider font-semibold">Drawdown</div>
          <div className="text-base sm:text-lg font-semibold text-sif-primary mt-0.5">
            Underwater curve (% below running peak)
          </div>
        </div>
        {data && (
          <div className="text-left sm:text-right">
            <div className="text-[10px] text-sif-muted uppercase tracking-wider font-semibold">Max Drawdown</div>
            <div className="text-base sm:text-lg font-bold font-mono loss">{data.max_drawdown}%</div>
          </div>
        )}
      </div>

      <div className="h-[220px] sm:h-[280px]">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data?.points || []} margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
            <defs>
              <linearGradient id="ddFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#EF4444" stopOpacity={0.05} />
                <stop offset="100%" stopColor="#EF4444" stopOpacity={0.4} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" vertical={false} />
            <XAxis
              dataKey="date"
              tick={{ fontSize: 10, fill: "#64748B" }}
              stroke="#CBD5E1"
              minTickGap={30}
            />
            <YAxis
              tick={{ fontSize: 10, fill: "#64748B" }}
              stroke="#CBD5E1"
              tickFormatter={(v) => `${v}%`}
              domain={["dataMin", 0]}
            />
            <Tooltip
              contentStyle={{
                background: "white",
                border: "1px solid #E2E8F0",
                borderRadius: "8px",
                fontSize: "12px",
              }}
              labelStyle={{ color: "#0B3C5D", fontWeight: 600 }}
              formatter={(v) => [`${v}%`, "Drawdown"]}
            />
            <Area
              type="monotone"
              dataKey="drawdown"
              stroke="#EF4444"
              strokeWidth={2}
              fill="url(#ddFill)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </section>
  );
}
